import React, { useEffect } from 'react';
import config from '../../config';

export const AmwaySeamlessRedirect = ({ redirect }) => {
  const payload = {
    redirectUri : `${config.NGC_SF_URL}/myshop`,
    headers: {
        "X-Amway-Channel": "WEB",
        "X-Amway-Tenant": "200",
        "X-Amway-Country": "th",
        "Accept-Language": "*"
    }
  }
  const state =  btoa(JSON.stringify(payload));
  useEffect(() => {
    const btn = document.getElementById('btn-submit');
    btn.click();
  }, []);

  return (
    <div>
      Loading...
      <form
        id="appForm"
        method="post"
        action={`${config.GLUU_IDP_URL}`}
      >
        <input
          type="hidden"
          name="scope"
          value={`openid`}
        />
        <input
          type="hidden"
          name="acr_values"
          value={`social_lbc`}
        />
        <input
          type="hidden"
          name="response_type"
          value={`code`}
        />
        <input
          type="hidden"
          name="state"
          value={`${state}`}
        />
        <input
          type="hidden"
          name="nonce"
          value={`${config.GLUU_IDP_NONCE}`}
        />
        <input
          type="hidden"
          name="client_id"
          id="client_id"
          value={`${config.NGC_CLIENTID}`}
        />
        <input
          type="hidden"
          name="redirect_uri"
          id="redirect_uri"
          value={`${config.NGC_REDIRECT_URI}`}
        />

        <input type="hidden" name="redirectTargetUrl" value={`${config.NGC_SF_URL}/myshop`} />
        <input
          id="btn-submit"
          type="submit"
          value="submit"
          style={{ opacity: 0 }}
        />
      </form>
    </div>
  );
};

export default AmwaySeamlessRedirect;
